import Dexie from 'dexie';
import 'dexie-observable';
import * as models from 'models';
import config from 'config';

class Database extends Dexie {
  _stores = {
    cidades: models.Cidade.describe(),
    contatos: models.Contato.describe(),
    culturas: models.Cultura.describe(),
    estados: models.Estado.describe(),
    etapas: models.Etapa.describe(),
    etapa_produto: models.EtapaProduto.describe(),
    fases: models.Fase.describe(),
    impactos: models.Impacto.describe(),
    pems: models.Pem.describe(),
    perguntas: models.Pergunta.describe(),
    respostas: models.Resposta.describe(),
    produtos: models.Produto.describe(),
    syncs: models.Sync.describe(),
    queue: models.Queue.describe(),
  };

  constructor(dbname, version) {
    super(dbname);
    this.version(version).stores(this._stores);
    this._init();
  }

  async _init() {
    try {
      this.cidades.mapToClass(models.Cidade);
      this.contatos.mapToClass(models.Contato);
      this.culturas.mapToClass(models.Cultura);
      this.estados.mapToClass(models.Estado);
      this.etapas.mapToClass(models.Etapa);
      this.etapa_produto.mapToClass(models.EtapaProduto);
      this.fases.mapToClass(models.Fase);
      this.impactos.mapToClass(models.Impacto);
      this.pems.mapToClass(models.Pem);
      this.perguntas.mapToClass(models.Pergunta);
      this.respostas.mapToClass(models.Resposta);
      this.produtos.mapToClass(models.Produto);
      this.syncs.mapToClass(models.Sync);
      this.queue.mapToClass(models.Queue);
      await this.open();
    } catch (woof) {
      console.error(`Open failed: ${woof.stack}`);
    }
  }

  async reset() {
    await this.delete();
    await this.open();
  }
}

export default new Database(config.DB_NAME, config.DB_VERSION);
